import { render, staticRenderFns } from "./chartsPage.vue?vue&type=template&id=62bd7d62&scoped=true&"
import script from "./chartsPage.vue?vue&type=script&lang=js&"
export * from "./chartsPage.vue?vue&type=script&lang=js&"
import style0 from "./chartsPage.vue?vue&type=style&index=0&id=62bd7d62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bd7d62",
  null
  
)

export default component.exports